import { useState, useEffect } from "react";
import { isBitSet, setBit } from "../utils";

const WeekDaysSelector = (props) => {
    const [customOverride, setCustomOverride] = useState(false);

    // Initialize with the provided value or default to Monday-Friday
    const initialValue =
        props.initialValue !== undefined ? props.initialValue : 62;

    // Function to convert bit value to day selections
    const bitValueToDays = (value) => {
        return {
            sun: isBitSet(value, 0),
            mon: isBitSet(value, 1),
            tue: isBitSet(value, 2),
            wed: isBitSet(value, 3),
            thu: isBitSet(value, 4),
            fri: isBitSet(value, 5),
            sat: isBitSet(value, 6),
        };
    };

    // Initialize state based on the initial value
    const [selectedDays, setSelectedDays] = useState(
        bitValueToDays(initialValue),
    );
    const [selectedOption, setSelectedOption] = useState(
        initialValue === 62 ? 5 : initialValue === 126 ? 6 : null,
    );
    const [runsOn, setRunsOn] = useState(initialValue);

    // Update state if initialValue prop changes
    useEffect(() => {
        if (props.initialValue !== undefined && props.initialValue !== runsOn) {
            setSelectedDays(bitValueToDays(props.initialValue));
            setRunsOn(props.initialValue);
            setSelectedOption(
                props.initialValue === 62
                    ? 5
                    : props.initialValue === 126
                      ? 6
                      : null,
            );
        }
    }, [props.initialValue]);

    const handleDaySelection = (day) => {
        const newSelectedDays = { ...selectedDays, [day]: !selectedDays[day] };
        setSelectedDays(newSelectedDays);

        const newRunsOn = calculateBitSum(newSelectedDays);
        setRunsOn(newRunsOn);

        if (props.onChange) {
            props.onChange(newRunsOn);
        }
        setSelectedOption(null);
        setCustomOverride(true);
    };

    const handle5Click = () => {
        if (!customOverride) {
            const newSelectedDays = {
                mon: true,
                tue: true,
                wed: true,
                thu: true,
                fri: true,
                sat: false,
                sun: false,
            };
            setSelectedDays(newSelectedDays);

            const newRunsOn = calculateBitSum(newSelectedDays);
            setRunsOn(newRunsOn);

            if (props.onChange) props.onChange(newRunsOn);
            setSelectedOption(5);
        } else {
            setSelectedOption(null);
        }
    };

    const resetDays = () => {
        setSelectedDays({
            mon: false,
            tue: false,
            wed: false,
            thu: false,
            fri: false,
            sat: false,
            sun: false,
        });
    };

    const handle6Click = () => {
        if (!customOverride) {
            const newSelectedDays = {
                mon: true,
                tue: true,
                wed: true,
                thu: true,
                fri: true,
                sat: true,
                sun: false,
            };
            setSelectedDays(newSelectedDays);

            const newRunsOn = calculateBitSum(newSelectedDays);
            setRunsOn(newRunsOn);

            if (props.onChange) props.onChange(newRunsOn);
            setSelectedOption(6);
        } else {
            setSelectedOption(null);
        }
    };

    const calculateBitSum = (days) => {
        let value = 0;
        if (days.sun) value = setBit(value, 0);
        if (days.mon) value = setBit(value, 1);
        if (days.tue) value = setBit(value, 2);
        if (days.wed) value = setBit(value, 3);
        if (days.thu) value = setBit(value, 4);
        if (days.fri) value = setBit(value, 5);
        if (days.sat) value = setBit(value, 6);
        return value;
    };

    // Generate unique IDs for each input based on the shift ID
    const shiftIdSuffix = props.shiftId ? `-${props.shiftId}` : "";

    return (
        <div>
            <div className="weekDays-selector">
                <input
                    type="checkbox"
                    id={`weekday-sun${shiftIdSuffix}`}
                    className="weekday"
                    checked={selectedDays.sun}
                    onChange={() => handleDaySelection("sun")}
                />
                <label htmlFor={`weekday-sun${shiftIdSuffix}`}>S</label>
                <input
                    type="checkbox"
                    id={`weekday-mon${shiftIdSuffix}`}
                    className="weekday"
                    checked={selectedDays.mon}
                    onChange={() => handleDaySelection("mon")}
                />
                <label htmlFor={`weekday-mon${shiftIdSuffix}`}>M</label>
                <input
                    type="checkbox"
                    id={`weekday-tue${shiftIdSuffix}`}
                    className="weekday"
                    checked={selectedDays.tue}
                    onChange={() => handleDaySelection("tue")}
                />
                <label htmlFor={`weekday-tue${shiftIdSuffix}`}>T</label>
                <input
                    type="checkbox"
                    id={`weekday-wed${shiftIdSuffix}`}
                    className="weekday"
                    checked={selectedDays.wed}
                    onChange={() => handleDaySelection("wed")}
                />
                <label htmlFor={`weekday-wed${shiftIdSuffix}`}>W</label>
                <input
                    type="checkbox"
                    id={`weekday-thu${shiftIdSuffix}`}
                    className="weekday"
                    checked={selectedDays.thu}
                    onChange={() => handleDaySelection("thu")}
                />
                <label htmlFor={`weekday-thu${shiftIdSuffix}`}>T</label>
                <input
                    type="checkbox"
                    id={`weekday-fri${shiftIdSuffix}`}
                    className="weekday"
                    checked={selectedDays.fri}
                    onChange={() => handleDaySelection("fri")}
                />
                <label htmlFor={`weekday-fri${shiftIdSuffix}`}>F</label>
                <input
                    type="checkbox"
                    id={`weekday-sat${shiftIdSuffix}`}
                    className="weekday"
                    checked={selectedDays.sat}
                    onChange={() => handleDaySelection("sat")}
                />
                <label htmlFor={`weekday-sat${shiftIdSuffix}`}>S</label>
                <label className="font-color-f2f2f2 font-weight-bold pr-1 vertical-align-center">
                    .
                </label>
                <input
                    type="checkbox"
                    id={`weekday-5${shiftIdSuffix}`}
                    className="weekday"
                    checked={selectedOption === 5}
                    onChange={handle5Click}
                />
                <label htmlFor={`weekday-5${shiftIdSuffix}`}>5</label>
                <input
                    type="checkbox"
                    id={`weekday-6${shiftIdSuffix}`}
                    className="weekday"
                    checked={selectedOption === 6}
                    onChange={handle6Click}
                />
                <label htmlFor={`weekday-6${shiftIdSuffix}`}>6</label>
            </div>
            {/* Uncomment for debugging */}
            {/*
      <div className="mt-2 small text-muted">
        Bit value: {runsOn}
      </div>
      */}
        </div>
    );
};
export default WeekDaysSelector;
